export default function (value = 3600 * 24 * 7) { // Une semaine de cache par défaut
	return target => {
		Object.defineProperty(target, 'cacheDuration', {
			configurable: false,
			enumerable: false,
			value,
			writable: false,
		});
	};
}